import { SlidersHorizontal } from "@phosphor-icons/react"
import { Button, FilterDrawer, FormGroup, Selector } from "@vesatogo/grass-core"
import { Dispatch, SetStateAction, useState } from "react"
import WhatsAppStatus from "~/constants/WhatsAppStatus"

export type EnquiryFilter = {
  whatsapp_status?: any
}

type Props = {
  filter: EnquiryFilter
  setFilter: Dispatch<SetStateAction<EnquiryFilter>>
}

export const EnquiryFilters = ({ filter, setFilter }: Props) => {
  const [isOpen, setOpen] = useState(false)
  return (
    <>
      <Button
        size="sm"
        intent="none"
        variant="outline"
        className="p-1.5 !border-1 !border-gray-400 rounded !rounded-l-none bg-gray-50 text-gray-500"
        onClick={() => setOpen(true)}
      >
        <SlidersHorizontal size={16} />
      </Button>

      <FilterDrawer
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => setOpen(false)}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
        tabs={[
          {
            id: 1,
            title: "WhatsApp Status",
            content: (
              <div className="flex flex-col gap-3">
                <FormGroup label="WhatsApp Status" className="w-full">
                  <Selector
                    options={Object.values(WhatsAppStatus)?.map(item => ({
                      id: item,
                      name: item,
                    }))}
                    value={filter.whatsapp_status}
                    onChange={value =>
                      setFilter(prev => ({
                        ...prev,
                        whatsapp_status: value,
                      }))
                    }
                  />
                </FormGroup>
              </div>
            ),
          },
        ]}
      />
    </>
  )
}
